<template>
  <div>
    <v-dialog v-model="dialog" fullscreen scrollable>
      <v-card>
        <v-toolbar dark flat absolute color="primary" width="100%">
          <v-toolbar-title>{{dialogTitle}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="cancelClick">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <!-- <v-toolbar-items>
            <v-btn dark text @click="close"> Save </v-btn>
          </v-toolbar-items> -->
        </v-toolbar>
        <v-card-title></v-card-title>
        <v-card-text  style="margin-top:100px;" >
          <v-container v-if="contract.influencer_details">
            <v-tabs
                centered
                v-model='selectedTab'
              >
                <v-tabs-slider></v-tabs-slider>
                <v-tab >
                  Invoice
                </v-tab>
                <v-tab >
                  Brief Details
                </v-tab>
                <v-tab v-if="hideRequiredActions()" >
                  Email Template
                </v-tab>
                <v-tab-item style='margin-top:20px;'>
                  <v-row>
                    <v-col cols="12" sm="12" md="12" lg="12" align="center">
                      <img :src="logoUrl" class="contract-logo" />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" md="12" lg="12" align="left">
                      <div>
                        <p style="margin: 0px 20px 0px 0px; font-weight: 600">
                          Kobe Global Technologies Pte Ltd.<br />
                          GST Registration no. 201608755R<br />
                          51 Goldhill Plaza<br />
                          #14-01<br />
                          Singapore 308900<br />
                          finance@getkobe.com
                        </p>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" md="12" lg="12" align="left">
                      <div style="border: 1px solid black">
                        <div style="background-color: #3F3FFF; border-bottom: 1px solid black; padding: 5px; color: white">
                          Content Creator Details
                        </div>
                        <div style="padding: 5px" v-if="contract.influencer_details.platform === 'tiktok'">
                          TikTok Handle: {{ contract.influencer_details.userHandle }}  <br />
                          <!-- Full name: {{ (contract.influencer_details.fullname || '-') }} -->
                        </div>
                        <div style="padding: 5px" v-else-if="contract.influencer_details.platform === 'instagram'">
                          Instagram Handle: {{ contract.influencer_details.userHandle }}  <br />
                          <!-- Full name: {{ (contract.influencer_details.fullname || '-' ) }} -->
                        </div>
                        <div style="padding: 5px" v-else-if="contract.influencer_details.platform === 'youtube'">
                          Youtube Handle: {{ contract.influencer_details.userHandle }}  <br />
                          <!-- Full name: {{ (contract.influencer_details.fullname || '-' ) }} -->
                        </div>
                        <div style="padding: 5px" v-else-if="contract.influencer_details.platform === 'twitter'">
                          X (Twitter) Handle: {{ contract.influencer_details.userHandle }}  <br />
                        </div>
                        <div style="padding: 5px" v-else-if="contract.influencer_details.platform === 'others'">
                          {{ contract.influencer_details.platformName | platformDisplayName }} Handle: {{ contract.influencer_details.userHandle }}  <br />
                          <!-- Full name: {{ (contract.influencer_details.fullname || '-' ) }} -->
                        </div>
                        <div style="padding: 5px" v-else>
                          Platform Handle: {{ contract.influencer_details.userHandle }}  <br />
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" md="12" lg="12" align="left">
                      <div style="border: 1px solid black">
                        <div style="background-color: #3F3FFF; border-bottom: 1px solid black; padding: 5px; color: white">Company Rep Details</div>
                        <div style="padding: 5px">
                          <strong>Kobe Global Technologies Pte Ltd.</strong> <br />
                          (+65) 6255 5662 <br />
                          finance@getkobe.com
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" md="12" lg="12" align="left">
                      <div style="border: 1px solid black">
                        <div style="background-color: #3F3FFF; border-bottom: 1px solid black; padding: 5px; color: white">Campaign Details</div>
                        <div style="padding: 5px">
                          <strong>{{ contract.brief.campaignName }}</strong> <br />
                          <!-- Campaign Period: {{ dateFormat(contract.brief.startDate) }} - {{ dateFormat(contract.brief.endDate) }} <br /> -->
                          Campaign Ref: {{contract.campaignID}}
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row v-if="contract.deliverables && showDeliverables">
                    <v-col cols="12" sm="12" md="12" lg="12" align="left">
                      <div >
                        <table style="width: 100%; border-top: 1px solid black;">
                          <thead style="background-color: #3F3FFF; color: white">
                            <tr style="border-left:1px solid black;">
                              <td style="text-align: center">DESCRIPTION</td>
                              <td style="text-align: center">QTY</td>
                              <!-- <td style="text-align: center">UNIT PRICE</td> -->
                              <td style="text-align: center">AMOUNT</td>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-if="contract.deliverables.no_of_stories" style="border-left:1px solid black;">
                              <td>IG Story</td>
                              <td style="text-align: center">{{contract.deliverables.no_of_stories}}</td>
                              <!-- <td style="text-align: center" :rowspan="getRowSpanCount">{{formatPayout(chkPayoutGST)}}</td> -->
                              <td style="text-align: center" :rowspan="getRowSpanCount" v-if="checkShowAmountRowSpan('no_of_stories')">{{formatPayout(chkPayoutGST)}}</td>
                            </tr>
                            <tr v-if="contract.deliverables.no_of_tiktok_posts" style="border-left:1px solid black;">
                              <td>TikTok Post</td>
                              <td style="text-align: center">{{contract.deliverables.no_of_tiktok_posts}}</td>
                              <!-- <td style="text-align: center" :rowspan="getRowSpanCount">{{formatPayout(chkPayoutGST)}}</td> -->
                              <td style="text-align: center" :rowspan="getRowSpanCount" v-if="checkShowAmountRowSpan('no_of_tiktok_posts')">{{formatPayout(chkPayoutGST)}}</td>
                            </tr>
                            <tr v-if="contract.deliverables.no_of_xhs_posts" style="border-left:1px solid black;">
                              <td>XHS Post</td>
                              <td style="text-align: center">{{contract.deliverables.no_of_xhs_posts}}</td>
                              <!-- <td style="text-align: center" :rowspan="getRowSpanCount">{{formatPayout(chkPayoutGST)}}</td> -->
                              <td style="text-align: center" :rowspan="getRowSpanCount" v-if="checkShowAmountRowSpan('no_of_xhs_posts')">{{formatPayout(chkPayoutGST)}}</td>
                            </tr>
                            <tr v-if="contract.deliverables.no_of_fb_posts" style="border-left:1px solid black;">
                              <td>Facebook </td>
                              <td style="text-align: center">{{contract.deliverables.no_of_fb_posts}}</td>
                              <td style="text-align: center" v-if="checkShowAmountRowSpan('no_of_fb_posts')" :rowspan="getRowSpanCount">{{formatPayout(chkPayoutGST)}}</td>
                            </tr>
                            <tr v-if="contract.deliverables.no_of_posts" style="border-left:1px solid black;">
                              <td>IG Post</td>
                              <td style="text-align: center">{{contract.deliverables.no_of_posts}}</td>
                              <!-- <td v-if="!contract.deliverables.no_of_stories" style="text-align: center" :rowspan="getRowSpanCount">{{formatPayout(chkPayoutGST)}}</td> -->
                              <td v-if="checkShowAmountRowSpan('no_of_posts')" style="text-align: center" :rowspan="getRowSpanCount">{{formatPayout(chkPayoutGST)}}</td>
                            </tr>
                            <tr v-if="contract.deliverables.no_of_carousels" style="border-left:1px solid black;">
                              <td>IG Carousel</td>
                              <td style="text-align: center">{{contract.deliverables.no_of_carousels}}</td>
                              <!-- <td v-if="!contract.deliverables.no_of_posts  && !contract.deliverables.no_of_stories" style="text-align: center" :rowspan="getRowSpanCount">{{formatPayout(chkPayoutGST)}}</td> -->
                              <td v-if="checkShowAmountRowSpan('no_of_carousels')" style="text-align: center" :rowspan="getRowSpanCount">{{formatPayout(chkPayoutGST)}}</td>
                            </tr>
                            <tr v-if="contract.deliverables.no_of_video" style="border-left:1px solid black;">
                              <td>IG Video</td>
                              <td style="text-align: center">{{contract.deliverables.no_of_video}}</td>
                              <!-- <td v-if="!contract.deliverables.no_of_carousels && !contract.deliverables.no_of_posts && !contract.deliverables.no_of_stories" style="text-align: center;" :rowspan="getRowSpanCount">{{formatPayout(chkPayoutGST)}}</td> -->
                              <td v-if="checkShowAmountRowSpan('no_of_video')" style="text-align: center;" :rowspan="getRowSpanCount">{{formatPayout(chkPayoutGST)}}</td>
                            </tr>
                            <tr v-if="contract.deliverables.no_of_igTv" style="border-left:1px solid black;">
                              <td>IG TV</td>
                              <td style="text-align: center">{{contract.deliverables.no_of_igTv}}</td>
                              <!-- <td v-if="!contract.deliverables.no_of_carousels && !contract.deliverables.no_of_video && !contract.deliverables.no_of_posts && !contract.deliverables.no_of_stories" style="text-align: center" :rowspan="getRowSpanCount">{{formatPayout(chkPayoutGST)}}</td> -->
                              <td v-if="checkShowAmountRowSpan('no_of_igTv')" style="text-align: center" :rowspan="getRowSpanCount">{{formatPayout(chkPayoutGST)}}</td>
                            </tr>
                            <tr v-if="contract.deliverables.no_of_reels" style="border-left:1px solid black;">
                              <td>IG Reels</td>
                              <td style="text-align: center">{{contract.deliverables.no_of_reels}}</td>
                              <td style="text-align: center" v-if="checkShowAmountRowSpan('no_of_reels')" :rowspan="getRowSpanCount">{{formatPayout(chkPayoutGST)}}</td>
                            </tr>
                            <tr v-if="contract.deliverables.no_of_li_posts" style="border-left:1px solid black;">
                              <td>LinkedIn Post</td>
                              <td style="text-align: center">{{contract.deliverables.no_of_li_posts}}</td>
                              <!-- <td style="text-align: center" :rowspan="getRowSpanCount">{{formatPayout(chkPayoutGST)}}</td> -->
                              <td style="text-align: center" :rowspan="getRowSpanCount" v-if="checkShowAmountRowSpan('no_of_li_posts')">{{formatPayout(chkPayoutGST)}}</td>
                            </tr>
                            <tr v-if="contract.deliverables.no_of_x_posts" style="border-left:1px solid black;">
                              <td>X (Twitter) Post</td>
                              <td style="text-align: center">{{contract.deliverables.no_of_x_posts}}</td>
                              <td style="text-align: center" :rowspan="getRowSpanCount" v-if="checkShowAmountRowSpan('no_of_x_posts')">{{formatPayout(chkPayoutGST)}}</td>
                            </tr>
                            <tr v-if="contract.deliverables.youtube" style="border-left:1px solid black;">
                              <td>Youtube</td>
                              <td style="text-align: center">{{contract.deliverables.youtube}}</td>
                              <td style="text-align: center" v-if="checkShowAmountRowSpan('youtube')" :rowspan="getRowSpanCount">{{formatPayout(chkPayoutGST)}}</td>
                            </tr>
                            <tr v-if="contract.deliverables.loading_whitelisting" style="border-left:1px solid black;">
                              <td>Loading/Whitelisting</td>
                              <td style="text-align: center">{{contract.deliverables.loading_whitelisting}}</td>
                              <td style="text-align: center" v-if="checkShowAmountRowSpan('loading_whitelisting')" :rowspan="getRowSpanCount">{{formatPayout(chkPayoutGST)}}</td>
                            </tr>
                            <tr v-if="contract.deliverables.exclusivity" style="border-left:1px solid black;">
                              <td>Exclusivity </td>
                              <td style="text-align: center">{{contract.deliverables.exclusivity}}</td>
                              <td style="text-align: center" v-if="checkShowAmountRowSpan('exclusivity')" :rowspan="getRowSpanCount">{{formatPayout(chkPayoutGST)}}</td>
                            </tr>
                            <tr v-if="contract.deliverables.physical_attendance" style="border-left:1px solid black;">
                              <td>Physical Attendance </td>
                              <td style="text-align: center">{{contract.deliverables.physical_attendance}}hrs</td>
                              <td style="text-align: center" v-if="checkShowAmountRowSpan('physical_attendance')" :rowspan="getRowSpanCount">{{formatPayout(chkPayoutGST)}}</td>
                            </tr>
                            <tr v-if="contract.deliverables.online_attendance" style="border-left:1px solid black;">
                              <td>Online Attendance </td>
                              <td style="text-align: center">{{contract.deliverables.online_attendance}}hrs</td>
                              <td style="text-align: center" v-if="checkShowAmountRowSpan('online_attendance')" :rowspan="getRowSpanCount">{{formatPayout(chkPayoutGST)}}</td>
                            </tr>
                            <tr
                            v-for="(custom, index) in contract.deliverables.custom"
                            :key="index"
                            style="border-left:1px solid black;">
                              <td>{{custom.label}}</td>
                              <td style="text-align: center">{{custom.value}}</td>
                              <td style="text-align: center" :rowspan="getRowSpanCount" v-if="index === 0 && checkShowAmountRowSpan('custom')">{{formatPayout(chkPayoutGST)}}</td>
                            </tr>
                            <tr
                            v-if="contract.payout_details"
                            v-for="(boostingFee, index) in contract.payout_details.boostingFees"
                            :key="index"
                            style="border-left:1px solid black;">
                              <td colspan="2">{{boostingFee.label}}</td>
                              <td style="text-align: center">{{formatPayout(boostingFee.value)}}</td>
                            </tr>
                            <tr v-if="contract.GST" style="border-left:1px solid black;">
                              <td>
                                GST
                              </td>
                              <td style="text-align: center">1</td>
                              <!-- <td style="text-align: center" >{{formatPayout(contract.GSTpercent)}}</td> -->
                              <td style="text-align: center" >{{formatPayout(contract.GSTpercent)}}</td>
                            </tr>
                            <tr v-if="contract.deliverableNotes" style="border-left:1px solid black;">
                              <td colspan="3" v-html="formatDesc(contract.deliverableNotes)"></td>
                            </tr>
                            <tr>
                              <td style="border:none !important;"></td>
                              <td colspan="3" style="background-color: #3F3FFF;text-align:center;color:white;border-left:1px solid black;">
                                <strong> TOTAL: {{formatPayout(contract.payout)}} </strong>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row v-if="contract.invoiceRemarks">
                    <v-col cols="12" sm="12" md="12" lg="12" align="left">
                      <div style="border: 1px solid black">
                        <div style="background-color: #3F3FFF; border-bottom: 1px solid black; padding: 5px; color: white">Remarks</div>
                        <div style="padding: 5px" v-html="formatDesc(contract.invoiceRemarks)">
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row v-if="showTerms">
                    <v-col cols="12" sm="12" md="12" lg="12" align="left">
                      <div>
                        <h1>Terms and Conditions</h1>
                        <ol>
                          <li>I have read and accepted the terms of use (<a href="https://www.getkobe.com/influencer-terms-use-agreement/" target="_blank">https://www.getkobe.com/influencer-terms-use-agreement/</a>).</li>
                          <li>I have read and understood supporting campaign details that accompany this brief.</li>
                          <li>I will not liaise with the Brand or the PR company, production company or any other agency involved in this campaign directly without consulting Kobe Global Technologies Pte Ltd for the duration of this campaign, and for the three months directly following job completion. If the Brand contacts me in this period for this campaign, I am under obligation to refer the client to Kobe Global Technologies Pte Ltd.</li>
                          <li>I understand that the rate for this campaign is agreed upon before the commencement of the job and cannot be negotiated in any terms once the job is completed.</li>
                          <li>I understand that the campaign brief and requirements may change and I am to provide updated availability and/or rates as required.</li>
                          <li>Once I have received confirmation of the brief, I will submit all drafts in a timely manner and according to the requested guidelines from the client. I will ensure the post goes live by the date of deadline and and understand if this is not met, or the client has any complaints about my performance,
                            I may forfeit my rate or be deducted a penalty by the client.</li>
                          <li>I agree that any content submitted to Kobe pursuant to a Campaign Agreement and accepted by a Client shall remain publicly accessible through your social media account(s) for a minimum of six (6) months, or such greater term as specified in the Campaign Agreement.</li>
                          <li>I own all of the content and information i create, in addition, the content that is covered by intellectual property rights, like photos and videos (IP content), You hereby represent and warrant that the content will be an original work of you and that the content will not infringe or misappropriate the intellectual property rights of any third party.</li>
                          <li>I will submit my payout and all post statistics on https://app.getkobe.com/ once job has been completed in order for payment to be processed. Payment will be received within 45 days after payout submission on the platform and/or payment clearance from client, whichever earlier.</li>
                          <li>If products are incorporated within the campaign, they should not be included for the purpose of sale or resale.</li>
                          <li>The client is legally obligated to provide appropriate and conspicuous credit to the original creators whenever content is shared on their social media platforms. The client agrees that any actions involving boosting, paid promotion, or similar techniques for content amplification will only be undertaken with prior consent from the relevant parties.</li>
                        </ol>
                      </div>
                    </v-col>
                  </v-row>
                  <!-- <v-form v-model="valid" ref="form" lazy-validation>
                  <v-row>
                    <v-col cols="12" sm="12" md="12" lg="12">
                      <v-checkbox v-model="tc" label="I have read and agree to the Terms and Conditions" :rules="[v => !!v || 'You must agree to continue!']">
                      </v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" md="12" lg="12" align="right">
                      <v-btn color="success" width="200" @click="agreeClick">Agree</v-btn>
                      <v-btn color="error" width="200" @click="close">Disagree</v-btn>
                    </v-col>
                  </v-row>
                  </v-form> -->
                </v-tab-item>
                <v-tab-item style='margin-top:20px;'>
                  <v-row>
                    <v-col>
                      <div v-html="briefDetailHTML"></div>
                    </v-col>
                  </v-row>
                </v-tab-item>
                <v-tab-item style='margin-top:20px;'>
                  <v-row>
                    <v-col cols="12" sm="12" md="3" lg="3">
                      <v-autocomplete
                        :items="users"
                        item-value="id"
                        item-text="name"
                        label="From"
                        v-model="selectedUser"
                        outlined
                        dense
                        @change="searchFilter"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row class="mt-0" v-if="contract.influencer_details.platform === 'tiktok' || !contract.influencer_details.contact_details.email">
                    <v-col cols="12" sm="12" md="3" lg="3" class="pt-0">
                      <v-text-field
                        placeholder="Influencer Email"
                        v-model="influencerEmail"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <vue-editor :editorToolbar="customToolbar" v-model="emailTemplateHTML"></vue-editor>
                </v-tab-item>
            </v-tabs>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-row style="margin-bottom:10px !important;">
            <v-col cols="12" align="right" style="margin-right:20px">
              <v-container >
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation>
                  <v-checkbox
                    v-model="agreement"
                    align="right"
                    v-if="showOptions"
                    :rules="[v => !!v || 'You must agree to continue!']"
                    label="I have read and agree to the Terms and Conditions"
                  ></v-checkbox>
                  <v-alert
                    text
                    v-model="alert"
                    dismissible
                    border="left"
                    type="error"
                    style="text-align:left"
                  >
                   Please indicate that you have read and agree to the terms and conditions.
                  </v-alert>
                  <v-btn
                  :loading="downloadloading"
                  :disabled="downloadloading"
                  color="blue-grey"
                  class="ma-2 white--text"
                  @click='download'
                  v-if="this.selectedTab === 0 || this.selectedTab === 1"
                  >Download
                  <v-icon right dark>mdi-cloud-download</v-icon>
                  </v-btn>
                  <v-btn v-if="showSendButton" color="success" @click="sendClick">
                    <v-icon left>mdi-send</v-icon>Send
                  </v-btn>
                  <v-btn v-if="showSubmitButton" color="success" @click="agreeClick">
                    <v-icon left>mdi-checkbox-marked-circle</v-icon>Agree</v-btn>
                  <v-btn v-if="showDeclineButton" color="error" @click="declineClick" >
                    <v-icon dark left> mdi-cancel</v-icon>Decline</v-btn>
                  <v-btn v-if="showCancelButton" color="info" @click="cancelClick">
                    <v-icon dark left>mdi-minus-circle</v-icon>Cancel</v-btn>
                </v-form>
              </v-container>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
      <v-snackbar v-model="snackbar" color="error" rounded="pill" :timeout="snackbarTimeout">
        {{snackbarText}}
        <template v-slot:action="{ snackattrs }">
          <v-btn
            color="white"
            text
            v-bind="snackattrs"
            @click="snackbar = false"
          >
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </v-dialog>
  </div>
</template>
<style scoped>
tr td {
  padding: 5px !important;
}
td {
  border-bottom: 1px solid black;
  border-right: 1px solid black;
}
li {
  list-style: decimal;
}
</style>
<script>
/* eslint-disable */
import campaignHelper from '../campaignHelper';
import moment from 'moment';
import * as pdfMake from 'pdfmake/build/pdfmake.js';
// import * as pdfFonts from '../../Campaign/custom-fonts';
// const vfs = pdfFonts.pdfMake.vfs;
// setTimeout(() => {
//   pdfMake.vfs = vfs
// }, 100)
import HTMLToPDF from '../../../editor/generator/HTMLToPDF'
import pairingAPIs from '../../Pairing/pairingAPIs';
import utils from '../../../../utils'
import { VueEditor } from 'vue2-editor';
import config from '@/config';
// import pdfPrinter from '../../../editor/generator/pdfGenerator';

export default {
  name: 'influencer_contract',
  components: {
    VueEditor
  },
  props: [
    'dialogTitle',
    'dialog',
    'close',
    'invoiceContract',
    'contract',
    'action',
    'didAgree',
    'didNotAgree',
    'showTerms',
    'showSendButton',
    'showSubmitButton',
    'showOptions',
    'showDeclineButton',
    'showCancelButton',
    'isAgreement',
    'emailTemplateHTML',
    'updateEmailTemplate',
    'content',
    'briefDetailHTML',
    'users',
    'selectedUser',
    'influencerEmail'],
  data () {
    return {
      valid: true,
      tc: false,
      rowSpanCount: 0,
      showRowSpan: '',
      showDeliverables: false,
      agreement: '',
      alert: false,
      selectedTab: '',
      emailTemplateHTMLUpdated: '',
      downloadloading: false,
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ['bold', 'italic', 'underline', 'strike'], // toggled buttons
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' }
        ],
        ['blockquote', 'code-block'],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
        [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
        [{ color: [] }, { background: [] }], // dropdown with defaults from theme
        ['link'],
        ['clean'] // remove formatting button
      ],
      snackbar: false,
      snackbarTimeout: 2000,
      snackbarText: ''
    }
  },
  watch: {
    alert: function() {
      if (this.alert) {
        setTimeout(() => {
          this.alert = false;
        }, 10000)
      }
    },
    emailTemplateHTML: function(nVal) {
      this.showRowSpan = ''
      this.emailTemplateHTMLUpdated = nVal
      this.showDeliverables = false
      // show deliverables after 100ms to effect row span changes
      setTimeout(() => {
        this.showDeliverables = true
      }, 500)
    }
  },
  computed: {
    logoUrl() {
      return config.kobeLogoDataURL;
    },
    getRowSpanCount() {
      this.rowSpanCount = 0
      if (this.contract.deliverables.no_of_carousels > 0) this.rowSpanCount++
      if (this.contract.deliverables.no_of_igTv > 0) this.rowSpanCount++
      if (this.contract.deliverables.no_of_tiktok_posts > 0) this.rowSpanCount++
      if (this.contract.deliverables.no_of_xhs_posts > 0) this.rowSpanCount++
      if (this.contract.deliverables.no_of_fb_posts > 0) this.rowSpanCount++
      if (this.contract.deliverables.no_of_posts > 0) this.rowSpanCount++
      if (this.contract.deliverables.no_of_stories > 0) this.rowSpanCount++
      if (this.contract.deliverables.no_of_video > 0) this.rowSpanCount++
      if (this.contract.deliverables.no_of_reels > 0) this.rowSpanCount++
      if (this.contract.deliverables.no_of_li_posts > 0) this.rowSpanCount++
      if (this.contract.deliverables.no_of_x_posts > 0) this.rowSpanCount++
      if (this.contract.deliverables.youtube > 0) this.rowSpanCount++
      if (this.contract.deliverables.loading_whitelisting) this.rowSpanCount++
      if (this.contract.deliverables.exclusivity) this.rowSpanCount++
      if (this.contract.deliverables.physical_attendance) this.rowSpanCount++
      if (this.contract.deliverables.online_attendance) this.rowSpanCount++
      if (this.contract.deliverables.custom) this.rowSpanCount += this.contract.deliverables.custom.length
      // if (this.contract.payout_details && this.contract.payout_details.boostingFees) this.rowSpanCount += this.contract.payout_details.boostingFees.length
      return this.rowSpanCount;
    },
    chkPayoutGST() {
      let payout = this.contract.payout;
      
      // Reduce boosting fees from payout
      if (this.contract.payout_details && this.contract.payout_details.boostingFees && Array.isArray(this.contract.payout_details.boostingFees)) {
        for (let boostingFee of this.contract.payout_details.boostingFees) {
          payout -= Number(boostingFee.value) || 0;
        }
      }
      
      if (this.contract.GST) {
        return Number(payout - this.contract.GSTpercent).toFixed(2)
      } else {
        return Number(payout).toFixed(2)
      }
    },
    currentUserRole: function() {
      return Number(this.$store.state.user.role)
    }
    // showCustomRowSpan() {
    //   return !this.contract.deliverables.no_of_carousels &&
    //   !this.contract.deliverables.no_of_tiktok_posts &&
    //   !this.contract.deliverables.no_of_video &&
    //   !this.contract.deliverables.no_of_posts &&
    //   !this.contract.deliverables.no_of_stories &&
    //   !this.contract.deliverables.no_of_igTv &&
    //   !this.contract.deliverables.no_of_reels &&
    //   !this.contract.deliverables.youtube &&
    //   !this.contract.deliverables.loading_whitelisting &&
    //   !this.contract.deliverables.exclusivity &&
    //   !this.contract.deliverables.physical_attendance &&
    //   !this.contract.deliverables.online_attendance
    // },
  },
  methods: {
    checkShowAmountRowSpan(type) {
      if (!this.showRowSpan) {
        this.showRowSpan = type
        return true
      } else if (this.showRowSpan === type) return true
      return false
    },
    async sendClick() {
      const payload = this.getRptOwnerCheckPayload(this.contract)
      await campaignHelper.invokeReportOwnerCheck(this, payload)
      if (this.contract.influencer_details.platform !== undefined || !this.contract.influencer_details.contact_details.email) {
        if (this.contract.influencer_details.platform === 'tiktok' || !this.contract.influencer_details.contact_details.email) {
          if (!this.influencerEmail) {
            this.snackbarText = 'Please Enter Influencer Email!'
            this.snackbar = true
            return false
          }
        }
      }
      this.updateEmailTemplate(this.emailTemplateHTMLUpdated)
      this.action(this.influencerEmail)
      this.close()
    },
    dateFormat(date) {
      return moment(date).format('DD/MM/yyyy')
    },
    async agreeClick() {
      this.$refs.form.validate()
      if (this.$refs.form.validate()) {
        let data = {
          pairingID: this.contract.id,
          agreement: this.agreement
        }
        await pairingAPIs.updateContractAgreement(data)
        this.didAgree()
      }
    },
    async declineClick() {
      let data = {
        pairingID: this.contract.id,
        agreement: false
      }
      await pairingAPIs.updateContractAgreement(data)
      this.didNotAgree()
    },
    cancelClick() {
      if (this.isAgreement) {
        this.alert = true
      } else {
        this.$refs.form.reset()
        this.close()
      }
    },
    formatPayout(n) {
      let currency = 'SGD'
      if (this.contract.currency) {
        currency = this.contract.currency
      }
      currency = utils.func.currencySym(currency)
      if (!n) return n
      if (n.toString().indexOf('-') !== -1) {
        let str = n.toString().split('-')
        return currency + ` ` + parseFloat(str[0]) + ' - ' + str[1]
      } else {
        return currency + ` ` + parseFloat(n)
      }
    },
    hideRequiredActions: function() {
      return config.userRoles.INFLUENCER !== this.currentUserRole;
    },
    download: async function() {
      const vm = this
      this.downloadloading = true
      let reportName = ''
      reportName += this.contract.brief ? this.contract.brief.campaignName + '_' : ''
      reportName += this.contract.influencer_details ? this.contract.influencer_details.userHandle + '_' : ''
      if (this.selectedTab === 0) {
        pdfMake.createPdf(vm.invoiceContract).download(reportName + 'invoice.pdf');
        // console.log(contract)
        this.downloadloading = false
      } else if (this.selectedTab === 1) {
        const htmlToPdf = new HTMLToPDF(this.briefDetailHTML, 'Arial')
        let pdfData = await htmlToPdf.generate()
        pdfMake.createPdf(pdfData).download(reportName + 'brief.pdf');
        // const blocksToPdf = new BlocksToPDF(this.content.blocks, 'Barlow')
        // let pdfData = await blocksToPdf.generate()
        // let pdfDocGenerator = pdfMake.createPdf(pdfData)
        // pdfDocGenerator.getDataUrl((dataUrl) => {
        //   this.contractFile = utils.func.dataURLtoFile(dataUrl, reportName + 'invoice.pdf')
        // })
        // pdfDocGenerator.download(reportName + 'brief.pdf');
        this.downloadloading = false
      }
    },
    getRptOwnerCheckPayload(item) {
      return Object.assign({}, {
        campaignID: item.CampaignID,
        handle: item.influencer_details ? item.influencer_details.userHandle : null,
        platform: item.influencer_details ? item.influencer_details.platform : null
      })
    },
    formatDesc(text) {
      return text.replaceAll('\n', '</br>')
    }
  },
  mounted() {
    setTimeout(function() {
      pdfMake.fonts = {
        Arial: {
          normal: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF',
          bold: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF'
        }
      }
    }, 1000);
  }
};
</script>

<style scoped>
.contract-logo {
  display: block;
  width: min(260px, 72vw);
  max-width: 260px;
  height: auto;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// InfluencerContractModal.vue?78b607ea